/** Generate a CSV string from rows + headers and trigger a browser download. */
export function downloadCsv(filename, headers, rows) {
    const escape = (v) => {
        if (v == null) return "";
        const s = String(v);
        if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
        return s;
    };
    const lines = [];
    lines.push(headers.map((h) => escape(h.label || h)).join(","));
    for (const r of rows) {
        lines.push(
            headers
                .map((h) => {
                    const key = h.key || h;
                    return escape(typeof key === "function" ? key(r) : r[key]);
                })
                .join(","),
        );
    }
    const csv = "\uFEFF" + lines.join("\n"); // BOM for Excel UTF-8
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
